export const DISCOUNT_LIST_CLEAR_STORE = "DISCOUNT_LIST_CLEAR_STORE";

export const DISCOUNT_LIST_SUMMURY_LOAD_START = "DISCOUNT_LIST_SUMMURY_LOAD_START";
export const DISCOUNT_LIST_SUMMURY_LOAD_SUCCESS = "DISCOUNT_LIST_SUMMURY_LOAD_SUCCESS";
export const DISCOUNT_LIST_SUMMURY_LOAD_FAIL = "DISCOUNT_LIST_SUMMURY_LOAD_FAIL";

export const DISCOUNT_LIST_LOAD_START = "DISCOUNT_LIST_LOAD_START";
export const DISCOUNT_LIST_LOAD_SUCCESS = "DISCOUNT_LIST_LOAD_SUCCESS";
export const DISCOUNT_LIST_LOAD_FAIL = "DISCOUNT_LIST_LOAD_FAIL";

export const DISCOUNT_LIST_REMOVE_START = "DISCOUNT_LIST_REMOVE_START";
export const DISCOUNT_LIST_REMOVE_SUCCESS = "DISCOUNT_LIST_REMOVE_SUCCESS";
export const DISCOUNT_LIST_REMOVE_FAIL = "DISCOUNT_LIST_REMOVE_FAIL";
